import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { CommonModule } from '@angular/common';

import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';

import {ComboboxComponent} from './combobox.component';
import {ComboboxSearchHighlightPipe, ComboboxSearchPipe} from './combobox.pipes';

@NgModule({
  declarations: [ComboboxComponent, ComboboxSearchPipe, ComboboxSearchHighlightPipe],
  imports: [FormsModule, ReactiveFormsModule, CommonModule, NgbDropdownModule],
  exports: [ComboboxComponent, ComboboxSearchPipe, ComboboxSearchHighlightPipe]
})
export class UiComboboxModule { }
